export default "__VITE_ASSET__2qMfTOXA__"